// Giriş sonrası dönülecek yol (?next=) yalnızca aynı origin'deki göreli bir
// yol olabilir. "//evil.com" ve "/\evil.com" tarayıcıda başka origin'e gider;
// tam URL'ler ve /login'in kendisi reddedilir.
export function safeNextPath(next: string | null | undefined, fallback = "/"): string {
  if (!next) return fallback;
  if (!next.startsWith("/")) return fallback;
  if (next.startsWith("//") || next.startsWith("/\\")) return fallback;
  if (Array.from(next).some((c) => c.charCodeAt(0) < 0x20)) return fallback;
  const pathname = next.split(/[?#]/, 1)[0];
  if (pathname === "/login" || pathname.startsWith("/login/")) return fallback;
  return next;
}

// Oturum düşünce gidilecek giriş adresi: mevcut sayfa ?next= ile korunur.
export function loginUrlWithNext(location: Pick<Location, "pathname" | "search" | "hash">): string {
  const current = `${location.pathname}${location.search}${location.hash}`;
  const next = safeNextPath(current, "");
  return next && next !== "/" ? `/login?next=${encodeURIComponent(next)}` : "/login";
}
